/* crst-bg-fx.js — page-specific FX for the Buying Guide. Relocated (behavior-for-behavior)
   from the former monolith sections/crst-buying-guide.liquid inline <script>, after the
   guide was split into independent crst-bg-* module sections:
     1) scroll-reveal — fade-up on enter, honors data-delay + reduced-motion, with a
        first-fold backstop (mirrors crst-why-fx.js / crst-home-fx.js) so a module sitting
        just below the fold isn't left blank for the first ~120px of scroll. (Replaces the
        monolith's 1200ms reveal-all fail-safe with the site-standard backstop.)
     2) chapter-nav PIN + scrollspy — CROSS-SECTION. The nav lives in crst-bg-nav; the
        chapter anchors (#specs #load #features #finder-sec #compare #redflags #faq) are
        spread across the sibling module sections. Wired document-level. CSS position:sticky
        can only stick inside its own (now short) section wrapper, so the bar is pinned via
        position:fixed toggled on a scroll threshold — mirroring the crst-business-dock
        fixed-dock pattern — and released against the end of the guide (last [data-crst-bg]
        section) so it rides up instead of hovering over the footer.
     3) load calculator (crst-bg-calculator).
     4) product finder (crst-bg-finder).

   Document-scoped + run-once (window.__crstBgFx) so every crst-bg-* section can include it
   safely (multiple includes = one execution). Each handler no-ops when its markup is
   absent, so it is harmless on a page built from any subset of the modules. */
(function(){
  if(window.__crstBgFx)return;window.__crstBgFx=1;
  var motionOK=!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function init(){
    var root=document;

    /* 1) scroll reveal — fade up on enter, honors data-delay + reduced-motion */
    (function(){
      var els=root.querySelectorAll('.reveal'); if(!els.length) return;
      if(window.matchMedia('(prefers-reduced-motion:reduce)').matches || !('IntersectionObserver' in window)){
        els.forEach(function(el){ el.classList.add('in'); }); return;
      }
      var io=new IntersectionObserver(function(ents){
        ents.forEach(function(en){
          if(!en.isIntersecting) return;
          var d=en.target.getAttribute('data-delay'); if(d) en.target.style.transitionDelay=d+'ms';
          en.target.classList.add('in'); io.unobserve(en.target);
        });
      },{threshold:0.08,rootMargin:'0px 0px -6% 0px'});
      /* First-fold backstop: anything at or near the fold reveals on load, so a module
         just below the fold isn't left blank until the first scroll. */
      var vh=window.innerHeight||document.documentElement.clientHeight||0;
      els.forEach(function(el){
        var r=vh?el.getBoundingClientRect():null;
        if(r && r.top<vh*1.2 && r.bottom>-40){
          var d=el.getAttribute('data-delay'); if(d) el.style.transitionDelay=d+'ms';
          el.classList.add('in');
        } else {
          io.observe(el);
        }
      });
    })();

    /* 2) chapter-nav pin + scrollspy (cross-section) */
    (function(){
      var nav=root.querySelector('.gnav[data-gnav]'); if(!nav) return;
      var wrap=root.querySelector('[data-gnav-wrap]')||nav.parentNode;
      var rail=nav.querySelector('.gnav-in'); if(!rail) return;
      var links=Array.prototype.slice.call(rail.querySelectorAll('a[href^="#"]'));
      var pairs=links.map(function(a){ return { a:a, sec:root.querySelector(a.getAttribute('href')) }; }).filter(function(p){ return !!p.sec; });
      var bgs=root.querySelectorAll('[data-crst-bg]');
      var lastBg=bgs.length?bgs[bgs.length-1]:null;

      function headerH(){
        var v=getComputedStyle(document.documentElement).getPropertyValue('--crst-header-h-shrunk');
        var n=parseInt(v,10); return isNaN(n)?60:n;
      }
      var HOFF=headerH();

      /* PIN — sticky can't span sibling section wrappers, so toggle position:fixed */
      function syncPin(){
        var top=wrap.getBoundingClientRect().top;
        if(top<=HOFF){
          if(!nav.classList.contains('pinned')){ wrap.style.height=nav.offsetHeight+'px'; nav.classList.add('pinned'); }
          /* release against the end of the guide so the bar rides up with the last
             section instead of hovering over the footer (mirrors the sticky boundary) */
          var navH=nav.offsetHeight;
          var limit=lastBg?(lastBg.getBoundingClientRect().bottom-navH):Infinity;
          nav.style.top=(limit<HOFF?limit:HOFF)+'px';
        } else if(nav.classList.contains('pinned')){
          nav.classList.remove('pinned'); wrap.style.height=''; nav.style.top='';
        }
      }

      /* SCROLLSPY */
      var current=null, lockUntil=0;
      function keepInView(a){
        if(rail.scrollWidth <= rail.clientWidth + 4) return;
        var L=a.offsetLeft, W=a.offsetWidth, sl=rail.scrollLeft, vw=rail.clientWidth;
        var behavior=motionOK ? 'smooth' : 'auto';
        if(L < sl + 16) rail.scrollTo({ left: Math.max(0, L - 16), behavior: behavior });
        else if(L + W > sl + vw - 16) rail.scrollTo({ left: L + W - vw + 16, behavior: behavior });
      }
      function setOn(id){
        if(id === current) return;
        current = id;
        pairs.forEach(function(p){
          var on = p.sec.id === id;
          p.a.classList.toggle('is-on', on);
          if(on){ p.a.setAttribute('aria-current','true'); keepInView(p.a); } else { p.a.removeAttribute('aria-current'); }
        });
      }
      function spy(){
        if(!pairs.length) return;
        if(Date.now() < lockUntil) return;
        var y = window.scrollY + HOFF + 52, id = null;
        pairs.forEach(function(p){ var top = p.sec.getBoundingClientRect().top + window.scrollY; if(top <= y) id = p.sec.id; });
        var doc = document.documentElement;
        if(window.scrollY + window.innerHeight >= doc.scrollHeight - 2) id = pairs[pairs.length - 1].sec.id;
        setOn(id);
      }
      links.forEach(function(a){
        a.addEventListener('click', function(e){
          var tgt = root.querySelector(a.getAttribute('href'));
          if(tgt){ e.preventDefault(); window.scrollTo({ top: tgt.getBoundingClientRect().top + window.scrollY - (HOFF + 52), behavior: motionOK ? 'smooth' : 'auto' }); }
          lockUntil = Date.now() + 900;
          setOn(a.getAttribute('href').slice(1));
        });
      });
      var ticking=false;
      function onScroll(){ if(ticking) return; ticking=true; requestAnimationFrame(function(){ ticking=false; syncPin(); spy(); }); }
      window.addEventListener('scroll', onScroll, { passive:true });
      window.addEventListener('resize', function(){ HOFF=headerH(); onScroll(); }, { passive:true });
      syncPin(); spy();
    })();

    /* 3) load calculator */
    (function(){
      var devs = Array.prototype.slice.call(root.querySelectorAll('.calc-dev'));
      if(!devs.length) return;
      var panel = root.querySelector('#calcPanel');
      var segsBox = root.querySelector('#calcSegs');
      var watts = root.querySelector('#calcWatts'), amps = root.querySelector('#calcAmps');
      var pct = root.querySelector('#calcPct'), head = root.querySelector('#calcHead');
      var note = root.querySelector('#calcNote'), verdict = root.querySelector('#calcVerdict');
      var reset = root.querySelector('#calcReset'), cta = root.querySelector('#calcCta'), ctaTx = root.querySelector('#calcCtaTx');
      var shopUrl = cta ? cta.getAttribute('href') : '#';
      var heavyUrl = cta && cta.getAttribute('data-heavy') ? cta.getAttribute('data-heavy') : shopUrl;
      var MAX = 1875, SAFE = 1500, SEG = 36, Z2 = Math.round(SEG * 0.8);
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var segs = [];
      for(var i = 0; i < SEG; i++){ var s = document.createElement('span'); segsBox.appendChild(s); segs.push(s); }

      function qtyOf(d){ return parseInt(d.getAttribute('data-qty'),10) || 0; }
      function total(){ var t = 0; devs.forEach(function(d){ t += (parseInt(d.getAttribute('data-w'),10) || 0) * qtyOf(d); }); return t; }
      function setQty(d, q){
        q = Math.max(0, Math.min(9, q));
        d.setAttribute('data-qty', q);
        d.classList.toggle('on', q > 0);
        d.querySelector('.dev-main').setAttribute('aria-pressed', q > 0 ? 'true' : 'false');
        d.querySelector('.dev-n').textContent = q;
        var w = parseInt(d.getAttribute('data-w'),10) || 0;
        d.querySelector('.dev-w').textContent = q > 1 ? ('×' + q + ' · ' + (w * q) + 'W') : (w + 'W');
      }
      var shown = 0, raf = null, settle = null;
      function paintNumbers(t){
        watts.textContent = Math.round(t);
        amps.textContent = (t / 125).toFixed(1);
        pct.textContent = Math.round(t / MAX * 100);
        head.textContent = Math.max(0, Math.round(MAX - t));
      }
      function tweenTo(target){
        if(raf) cancelAnimationFrame(raf);
        if(settle) clearTimeout(settle);
        if(reduceMotion || document.hidden){ shown = target; paintNumbers(target); return; }
        var from = shown, t0 = null, DUR = 380;
        function step(ts){
          if(t0 === null) t0 = ts;
          var k = Math.min(1, (ts - t0) / DUR);
          k = 1 - Math.pow(1 - k, 3);
          shown = from + (target - from) * k;
          paintNumbers(shown);
          if(k < 1){ raf = requestAnimationFrame(step); } else { raf = null; }
        }
        raf = requestAnimationFrame(step);
        settle = setTimeout(function(){
          if(shown !== target){ if(raf){ cancelAnimationFrame(raf); raf = null; } shown = target; paintNumbers(target); }
        }, DUR + 150);
      }
      var prevState = 'idle';
      function render(){
        var t = total();
        var state = t === 0 ? 'idle' : (t <= SAFE ? 'safe' : (t <= MAX ? 'warn' : 'over'));
        tweenTo(t);
        var lit = t === 0 ? 0 : Math.max(1, Math.round(Math.min(1, t / MAX) * SEG));
        segs.forEach(function(s, i){ s.classList.toggle('lit', i < lit); s.classList.toggle('z2', i < lit && i >= Z2); });
        panel.setAttribute('data-state', state);
        reset.hidden = t === 0;
        note.classList.remove('warn','over');
        if(state === 'idle'){
          verdict.textContent = 'STANDBY';
          note.innerHTML = 'Tap the devices you’d plug in. We’ll total the draw against a standard <b>15A / 1875W</b> strip.';
          cta.hidden = true;
        } else if(state === 'safe'){
          verdict.textContent = 'SAFE';
          note.innerHTML = '<b>You’re in the safe zone.</b> Any 15A CRST strip carries this load with headroom — pick by outlets and features, not capacity.';
          cta.hidden = false; cta.href = shopUrl;
          ctaTx.textContent = 'Shop 15A strips — every model fits this load';
        } else if(state === 'warn'){
          verdict.textContent = 'CAUTION';
          note.innerHTML = '<b>Close to the limit.</b> Sustained loads should stay under 80% (≈1500W). Move a heavy device to its own outlet.';
          cta.hidden = false; cta.href = heavyUrl;
          ctaTx.textContent = 'See 20A heavy-duty strips with more headroom';
        } else {
          verdict.textContent = 'TRIPPED';
          note.classList.add('over');
          note.innerHTML = '<b>Over 15A — the breaker just tripped.</b> High-draw appliances like heaters belong on their own wall outlet, never a strip.';
          cta.hidden = true;
        }
        if(state === 'warn') note.classList.add('warn');
        if(state === 'over' && prevState !== 'over' && !reduceMotion){
          panel.classList.remove('tripped'); void panel.offsetWidth; panel.classList.add('tripped');
        }
        prevState = state;
      }
      devs.forEach(function(d){
        d.querySelector('.dev-main').addEventListener('click', function(){ setQty(d, qtyOf(d) > 0 ? 0 : 1); render(); });
        d.querySelector('.dev-inc').addEventListener('click', function(){ setQty(d, qtyOf(d) + 1); render(); });
        d.querySelector('.dev-dec').addEventListener('click', function(){ setQty(d, qtyOf(d) - 1); render(); });
      });
      panel.addEventListener('animationend', function(){ panel.classList.remove('tripped'); });
      reset.addEventListener('click', function(){ devs.forEach(function(d){ setQty(d, 0); }); render(); });
      render();
    })();

    /* 4) product finder */
    (function(){
      var box = root.querySelector('#finder');
      if(!box) return;
      var catEl = root.querySelector('[data-finder-catalog]');
      var reaEl = root.querySelector('[data-finder-reasons]');
      var CAT = {}, REASONS = {};
      try { CAT = JSON.parse(catEl.textContent) || {}; } catch(e){}
      try { REASONS = JSON.parse(reaEl.textContent) || {}; } catch(e){}

      /* location × priority decision matrix — kept exactly as the design */
      var PICKS = {
        desk:   { protect:['p4','p1'], outlets:['p2','p4'], usb:['p1','p6'], mount:['p1','p3'] },
        shop:   { protect:['p3','p5'], outlets:['p5','p2'], usb:['p1','p7'], mount:['p3','p5'] },
        av:     { protect:['p4','p5'], outlets:['p2','p5'], usb:['p4','p6'], mount:['p5','p3'] },
        gaming: { protect:['p4','p6'], outlets:['p4','p2'], usb:['p6','p1'], mount:['p3','p6'] }
      };
      var state = { loc:null, pri:null }, wasShown = false;
      box.addEventListener('click', function(e){
        var btn = e.target.closest('.finder-opt');
        if(!btn) return;
        var q = btn.getAttribute('data-q'), v = btn.getAttribute('data-v');
        state[q] = v;
        Array.prototype.forEach.call(box.querySelectorAll('.finder-opt[data-q="'+q+'"]'), function(b){ b.classList.toggle('on', b === btn); });
        render();
      });
      function esc(s){ return String(s||'').replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
      function render(){
        var res = root.querySelector('#finderRes');
        if(!res) return;
        if(!state.loc || !state.pri){ res.classList.remove('show'); return; }
        var ids = (PICKS[state.loc] && PICKS[state.loc][state.pri]) || [];
        var html = ids.map(function(id){
          var p = CAT[id]; if(!p) return '';
          var was = p.compare ? '<s>' + esc(p.compare) + '</s>' : '';
          return '<article class="fpick">' +
            '<img src="' + esc(p.img) + '" alt="' + esc(p.name) + '" loading="lazy"/>' +
            '<div class="f-mid">' +
              '<h4><a href="' + esc(p.url) + '">' + esc(p.name) + '</a></h4>' +
              (REASONS[id] ? '<p class="why">' + esc(REASONS[id]) + '</p>' : '') +
              '<div class="f-row"><span class="price">' + esc(p.price) + was + '</span>' +
              '<a class="view" href="' + esc(p.url) + '">View</a></div>' +
            '</div></article>';
        }).filter(Boolean).join('');
        var cards = root.querySelector('#finderCards');
        cards.innerHTML = html || '<p class="finder-empty">No matching product is configured yet. Add product picks in the theme editor.</p>';
        res.classList.add('show');
        if(!wasShown){
          wasShown = true;
          requestAnimationFrame(function(){
            var r = res.getBoundingClientRect(), vh = window.innerHeight;
            if(r.bottom > vh - 40){ var by = Math.max(0, Math.min(r.bottom - vh + 60, r.top - 140)); if(by > 0) window.scrollBy({ top: by, behavior: motionOK ? 'smooth' : 'auto' }); }
          });
        }
      }
    })();
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init);
  } else {
    init();
  }
})();
